import { HawkSearchComponents, PageSizeComponentConfig, PageSizeComponentModel, PaginationOption } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './page-size.component.hbs';

export class PageSizeComponent extends BaseComponent<PageSizeComponentConfig, Array<PaginationOption>, PageSizeComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'page-size';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = true;

    protected override renderContent(): boolean {
        return !!this.data?.length;
    }

    protected override getContentModel(): PageSizeComponentModel {
        return {
            options: this.data!
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-page-size]').forEach((e) => {
            e.addEventListener('change', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLSelectElement;
                const pageSize = parseInt(element.value);

                searchService.setPageSize(pageSize);
            });
        });
    }
}
